// extracted by mini-css-extract-plugin
module.exports = {"Audio":"Audio_Audio__1hJSl","active":"Audio_active__1IHCm","AudioTitle":"Audio_AudioTitle__2iUQQ"};